export const paths = {
    ADMIN: 'admin',
    API_ADMIN_END_GAME: 'api/admin/end-game',
    API_ADMIN_RESTORE_SNAPSHOT: 'api/admin/restore-snapshot',
    API_CLONEABLEGAME: 'api/cloneablegame',
    API_CREATEGAME: 'api/creategame',
    API_GAME: 'api/game',
    API_GAME_HISTORY: 'api/game/history',
    API_GAME_LOGS: 'api/game/logs',
    API_GAMES: 'api/games',
    API_IPS: 'api/ips',
    API_METRICS: 'api/metrics',
    API_LOGOUT: 'api/logout',
    API_PLAYER: 'api/player',
    API_PROFILE: 'api/profile',
    API_SPECTATOR: 'api/spectator',
    API_STATS: 'api/stats',
    API_WAITING_FOR: 'api/waitingfor',
    AUTH_DISCORD_CALLBACK: 'auth/discord/callback',
    AUTOPASS: 'autopass',
    CARDS: 'cards',
    GAME: 'game',
    GAMES_OVERVIEW: 'games-overview',
    HELP: 'help',
    LOAD: 'load',
    LOAD_GAME: 'load_game',
    LOGIN: 'login',
    NEW_GAME: 'new-game',
    PLAYER: 'player',
    PLAYER_INPUT: 'player/input',
    RESET: 'reset',
    SPECTATOR: 'spectator',
    THE_END: 'the-end',
};
